import React from 'react';
import { Grid } from '@mui/material';
import AddOnCard from './components/BlockCard';
import { AllAddOns as allAddOns } from 'common/modules/plans/add-ons/types';
import { useTranslation } from 'react-i18next';
import { getAddOnDetails, isAddOnVisible } from 'common/modules/plans';
import { chain } from 'lodash';

const AllBlocks = () => {
	const { t } = useTranslation();

	const addOns = chain(allAddOns)
		.filter((addOn) => isAddOnVisible(addOn))
		.sortBy((addOn) => getAddOnDetails(addOn, t).name)
		.value();

	return (
		<Grid container spacing={3}>
			{addOns.map((addOn) => (
				<Grid key={addOn} item xs={12} md={4}>
					<AddOnCard addOn={addOn} />
				</Grid>
			))}
		</Grid>
	);
};

export default AllBlocks;
